import React from 'react';
import styled from '@emotion/styled'

const ThoughtDetailsComponent = ({ date, readTime, className }) => (
  <ThoughtDetails className={className}>
    <div>{date}</div>
  </ThoughtDetails>
);

export const ThoughtDetails = styled.h4`

    display: flex;
    align-items: center;
`;

export default ThoughtDetailsComponent;
